export default __webpack_public_path__ + "static/media/twitter-icon-input.fe968b4c.svg";